export enum TranslateAudio {
    YES,
    NO
}

export class AudioQueueItem {

    constructor(private audioFile: string,
                private translateAudio: TranslateAudio,
                public successCallback?: Function,
                public errorCallback?: Function,
                public playbackCallback?: Function) {}

    public getAudioFile(): string {
        return this.audioFile;
    }

    public shouldTranslate(): boolean {
        return this.translateAudio === TranslateAudio.YES;
    }
}
